import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import OaDivider from '@orientaction/commons/OaDivider';
import { AdminTestContext } from '@orientaction/Context';
import { Fragment, useContext } from 'react';
import Item from './Item';
import style from './style';
import YoutubeIframe from '../../../../../../../../VideoYoutubeEmbed';

const CardContent = ({ responses, idAglomeration }: any) => {
  const classes = style();
  const { test } = useContext<any>(AdminTestContext);

  return (
    <Card className={classes.cardContainer} variant="elevation" elevation={0}>
      <Grid container={true} spacing={2}>
        {test?.aglomerations[idAglomeration]?.questions[
          test?.aglomerations[idAglomeration]?.questions.findIndex(
            (q: any) => q.responses === responses
          )
        ]?.mediaUrl && (
          <Grid item={true} xl={12} sm={12} md={12} style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}>
            {test?.aglomerations[idAglomeration]?.questions[
              test?.aglomerations[idAglomeration]?.questions.findIndex(
                (q: any) => q.responses === responses
              )
            ]?.mediaType === 'image' ? (
              <img
                src={
                  test?.aglomerations[idAglomeration]?.questions[
                    test?.aglomerations[idAglomeration]?.questions.findIndex(
                      (q: any) => q.responses === responses
                    )
                  ]?.mediaUrl
                }
                alt="Question"
                style={{
                  width: 200,
                  height: 150,
                  objectFit: 'cover',
                  marginBottom: 16,
                  borderRadius: 9,
                }}
              />
            ) : (
              test?.aglomerations[idAglomeration]?.questions[
                test?.aglomerations[idAglomeration]?.questions.findIndex(
                  (q: any) => q.responses === responses
                )
              ]?.mediaType === 'video' && (
                <div style={{ marginBottom: 16, fontSize: 14 }}>
                  <span style={{ color: '#5763FF' }}>Lien de la vidéo : </span>
                  <a 
                    href={test?.aglomerations[idAglomeration]?.questions[
                      test?.aglomerations[idAglomeration]?.questions.findIndex(
                        (q: any) => q.responses === responses
                      )
                    ]?.mediaUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#000A8C', textDecoration: 'none' }}
                  >
                    {test?.aglomerations[idAglomeration]?.questions[
                      test?.aglomerations[idAglomeration]?.questions.findIndex(
                        (q: any) => q.responses === responses
                      )
                    ]?.mediaUrl}
                  </a>
                </div>
              )
            )}
          </Grid>
        )}
        <Grid
          className={classes.accordionResponseSectionTitleContainer}
          item={true}
          xl={12}
          sm={12}
          md={12}
          style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Typography className={classes.accordionResponseSectionTitle} component="h1">
            Réponses
          </Typography>
        </Grid>
        {responses?.map((response: any) => (
          <Fragment key={response.id}>
            <OaDivider overrideDividerClassname={classes.overrideDividerClassname} />
            <Item key={response.id} response={response} />
          </Fragment>
        ))}
      </Grid>
    </Card>
  );
};

export default CardContent;
